import type { ResourceT } from "../schema/resource";
import { FaultEventColumns } from "../schema/resource/columns";

// Classify expanded resources: systems include event columns, aggregates include fault impacts.
export function getDatasetRequirements(
  resources: ResourceT[],
  faults: { name: string; manual: boolean }[],
) {
  const manualFaultNames = new Set(faults.filter(fault => fault.manual).map(fault => fault.name));
  let hasFaults = false;
  let diagnosedEvents = false;
  let manualEvents = false;

  for (const resource of resources) {
    if (resource.kind !== "FAULT") continue;
    hasFaults = true;
    if (!FaultEventColumns.is(resource.column)) continue;
    if (manualFaultNames.has(resource.identifier)) manualEvents = true;
    else diagnosedEvents = true;
  }

  return { faults: hasFaults, diagnosedEvents, manualEvents };
}
